import React from 'react';
import DataLoader from '../../../../../../components/Common/Loader/DataLoader';
import GridLayout from '../../../../../../components/GridLayout';

const SidebarLoader = () => {
  function renderLoaderCard({ item }) {
    return <DataLoader isBordered={true} gapBetweenGrids={16} gridData={item?.data} />;
  }

  return (
    <GridLayout
      gap={20}
      data={[
        {
          data: [
            { height: 52, flex: 1 },
            { height: 52, flex: 1 },
            { height: 52, flex: 1 },
            { height: 52, flex: 1 },
            { height: 52, flex: 1 },
            { height: 52, flex: 1 }
          ]
        }
      ]}
      renderItem={renderLoaderCard}
    />
  );
};

export default SidebarLoader;
